import { render, staticRenderFns } from "./TransfererStudent.vue?vue&type=template&id=e7851cd2&scoped=true&"
import script from "./TransfererStudent.vue?vue&type=script&lang=js&"
export * from "./TransfererStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7851cd2",
  null
  
)

export default component.exports